// Storefront settings management
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

const STOREFRONT_ID = 'main';

/**
 * Get storefront settings
 */
export const getStorefrontSettings = async () => {
  try {
    const storefrontRef = doc(db, 'storefront', STOREFRONT_ID);
    const snapshot = await getDoc(storefrontRef);
    
    if (snapshot.exists()) {
      return { id: snapshot.id, ...snapshot.data() };
    }
    
    // Return default settings if none exist
    return {
      id: STOREFRONT_ID,
      profilePicture: '',
      displayName: '',
      bio: '',
      // Hero Section
      heroBadge: 'Cultural Rewiring & Self-Love',
      heroTagline: 'Return to your',
      heroTaglineHighlight: 'truest self.',
      heroDescription: 'Helping women heal, set boundaries, and rise higher through feminine energy, nervous system regulation, and cultural conditioning healing.',
      // About Section
      aboutTitle: 'Who I Am',
      aboutQuote: 'Fabiha is a self-love and cultural rewiring coach with 8+ years of experience in mindset work, manifestation, and inner child healing.',
      aboutContent1: 'I blend clinical knowledge (as an NHS pharmacist), mind-body principles, and spiritual alignment practices to help women reconnect with themselves.',
      aboutContent2: 'My mission is to help you break cultural conditioning and build a life rooted in confidence and peace.',
      aboutCredentials: [
        'Trained in meditation facilitation',
        'LOA & mindset experience',
        'South Asian background',
        'Trauma-informed approach',
        'Heart-centred coaching style'
      ],
      aboutPhilosophyTitle: 'My Philosophy',
      aboutPhilosophy: 'Healing isn\'t about becoming someone new. It\'s about unlearning who you were told to be, so you can be who you truly are.',
      aboutPhilosophyAuthor: '— Fabiha',
      // Programme Section
      programmeTitle: '12-Week 1:1 Coaching Programme',
      programmeDescription: 'A structured progression for feminine energy, cultural healing, and personalized nervous system tools.',
      programmeFeatures: [
        'Weekly 1:1 Zoom calls',
        'Tailored worksheets',
        'Journaling prompts',
        'Voice note/DM support',
        'Personalised meditation',
        'Feminine energy tools',
        'Nervous system regulation',
        'Cultural conditioning healing'
      ],
      programmePrice: 555,
      programmeOriginalPrice: 1111,
      programmePriceNote: 'Full price from early 2026',
      programmeBadge: 'Intro Price',
      programmePaymentNote: 'Payment plans available upon request.',
      // Freebie Section
      freebieTitle: 'Free Guided Meditation:',
      freebieTitleHighlight: '"Return to Self"',
      freebieDescription: 'Reconnect with your inner peace. Enter your details below to receive this powerful audio experience directly to your inbox.',
      freebieDisclaimer: 'You\'ll also be added to my newsletter for weekly tips on self-love & alignment. Unsubscribe anytime.',
      socialLinks: {
        instagram: '',
        tiktok: '',
        youtube: '',
        twitter: ''
      },
      sections: [],
      colors: {
        primary: '#c5a059',
        secondary: '#d48c95',
        background: '#fdfbf7'
      }
    };
  } catch (error) {
    console.error('Error getting storefront settings:', error);
    return null;
  }
};

/**
 * Update storefront settings
 */
export const updateStorefrontSettings = async (settings) => {
  try {
    const storefrontRef = doc(db, 'storefront', STOREFRONT_ID);
    await setDoc(storefrontRef, {
      ...settings,
      updatedAt: serverTimestamp()
    }, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Error updating storefront settings:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update section order (for drag-and-drop)
 */
export const updateSectionOrder = async (sections) => {
  try {
    const storefrontRef = doc(db, 'storefront', STOREFRONT_ID);
    await updateDoc(storefrontRef, {
      sections,
      updatedAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating section order:', error);
    return { success: false, error: error.message };
  }
};

